import logo from './logo.svg';
import './App.css';
import TrueFalseGame from './TrueFalseGame';
import Puzzle from './puzzle';
import QuizGame from './teszt.tsx';
import MemoryGame from './memoria.jsx';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js"; // Opcionális, ha JavaScript funkciókat is használnál


function App() {
  return (
    <>
    <div><MemoryGame /></div>
    </>
    
  );
}

export default App;
